import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

module.exports = {
  // "Ancestry": ({data, geo, geo_aggregation}) => <div>Table</div>,
  // "LOTE Speakers":  ({data, geo, geo_aggregation}) => <div>Table</div>,
  // "Languages Spoken at Home": ({data, geo, geo_aggregation}) => <div>Table</div>,
  // "Proficiency in English": ({data, geo, geo_aggregation}) => <div>Table</div>,
  // "Religion": ({data, geo, geo_aggregation}) => <div>Table</div>,
  // "Citizenship": ({data, geo, geo_aggregation}) => <div>Table</div>
};



// WEBPACK FOOTER //
// ./components/Tables/LanguageAndCulture.js